export default __webpack_public_path__ + "static/media/districts.e790cc0b.yml";